import { render, staticRenderFns } from "./errorPage404.vue?vue&type=template&id=48f054d4&scoped=true"
import script from "./errorPage404.vue?vue&type=script&lang=js"
export * from "./errorPage404.vue?vue&type=script&lang=js"
import style0 from "./errorPage404.vue?vue&type=style&index=0&id=48f054d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f054d4",
  null
  
)

export default component.exports